import React, { createContext, useState, useContext } from "react";
import { code } from "../utils";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [otp, setOtp] = useState({});
  const [email, setEmail] = useState(null);
  const [name, setName] = useState(null);

  const getOtp = (data) => {
    setOtp({
      otp: code.otpCode(),
      time: code.lifeTime(data.time),
      isOTP: true,
    });
    setEmail(data.email);
    setName(data.name);
  };

  const otpCode = otp.otp;

  if (email && name )  {
    // authCRUD
    //   .sendOTPEmail(emailData)
    //   .then(() => {})
    //   .catch(() => {});
  }

  return (
    <AuthContext.Provider value={{ otp, getOtp }}>
      {children}
    </AuthContext.Provider>
  );
};
